import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@bw/shared/hooks";
import { hasPlatformConsoleAccess } from "../platformAccess";

export function PlatformAccessGuard() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box
        role="status"
        aria-label="Loading"
        sx={{
          display: "flex",
          minHeight: "100dvh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={36} />
      </Box>
    );
  }

  if (!user) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }

  if (!hasPlatformConsoleAccess(user)) {
    return <Navigate to="/access-denied" replace />;
  }

  return <Outlet />;
}
